import { ArrowUpRight } from "lucide-react";
import { AUTHOR, REVIEWER } from "../../content/blog/authors";

const PersonCard = ({ person, role, testid }) => (
  <div className="bg-[#0c0c0c] p-7 h-full" data-testid={testid}>
    <p className="eyebrow mb-2">{role}</p>
    <h3 className="font-head font-extrabold uppercase text-xl mb-1">{person.name}</h3>
    <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-volt mb-4">{person.credentials}</p>
    <p className="text-zinc-400 text-sm leading-relaxed mb-5">{person.bio}</p>
    <div className="flex flex-wrap gap-x-5 gap-y-2">
      <a href={person.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-zinc-300 hover:text-volt transition-colors font-mono2 text-[11px] uppercase tracking-wider">
        {person.instagramHandle} <ArrowUpRight size={12} />
      </a>
      <a href={person.profile} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-zinc-300 hover:text-volt transition-colors font-mono2 text-[11px] uppercase tracking-wider">
        {person.profileLabel} <ArrowUpRight size={12} />
      </a>
    </div>
  </div>
);

export const AuthorBox = () => (
  <section className="my-14" data-testid="article-author-section">
    <p className="eyebrow mb-4">Written & Reviewed By</p>
    <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
      <PersonCard person={AUTHOR} role="Author" testid="author-card" />
      <PersonCard person={REVIEWER} role="Reviewer" testid="reviewer-card" />
    </div>
  </section>
);
